/**
 * Validate that a redirect path is safe (relative, no protocol).
 * Returns the path if safe, or the fallback otherwise.
 */
export function sanitizeRedirect(
  redirect: string | null,
  fallback = '/app/dashboard'
): string {
  if (!redirect) return fallback;
  if (
    redirect.startsWith('/') &&
    !redirect.startsWith('//') &&
    !redirect.includes('://') &&
    !redirect.includes('\\')
  ) {
    return redirect;
  }
  return fallback;
}
